import { http } from "@canvas/api";

export interface SwatchLendingReturnReq {
  endpoint: "ragnarok.swatch.v1.lendings.:inventoryId.return";
  body: SwatchLendingReturnRequestBody;
}

export interface SwatchLendingReturnRequestBody {
  inventory_id: number;
  data: object;
  // inventory_id: number;
  // issued_to: number;
  // issue_remarks: string | null;
  // expected_return_date: string | null;
}

export interface SwatchLendingReturnRes {}

export function put(
  req: SwatchLendingReturnReq
): Promise<SwatchLendingReturnRes> {
  return http
    .PUT(
      `/ragnarok/swatch/v1/inventory/${req.body.inventory_id}/return`,
      JSON.stringify(req.body.data),
      { 'Content-Type': 'application/json' }
    )
    .then((response: SwatchLendingReturnRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
